// extracted by mini-css-extract-plugin
module.exports = {"member":"member-module--member--23wMx"};